<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    :town-selection="false"
    :region-selection="false"
    :province-selection="false"
  />
</template>

<script setup>
import {ref} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryTableConfig from '../query-table.view-config.js';
import {NATIONAL_PARKS_SCHEMA} from './query-national-parks-table.view-config.js';
import {
  searchNationalPark,
  viewNationalParkPdf,
} from '@/api/national-park/national-park.api';
import {
  searchNationalParkHtml,
  searchNationalParkPdf,
  getNationalParkPdf,
} from '@/api/national-park/national-park.api.pdf.js';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const {copy} = useClipboard();
// #endregion

// #region Functions
async function goNationalPark({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 10;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}
function nationalParkToText({name, province, region}) {
  const res = `
    Nombre: ${name}
    Provincia: ${province}
    Comunidad Autónoma: ${region}
    `;
  return res;
}
async function printNationalPark(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(
      data.id,
      'Parque Nacional - ' + data.name,
      getNationalParkPdf,
    );
  }
}
async function htmlNationalParkQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery(
      'Informe Parques nacionales',
      searchNationalParkHtml,
      'html',
    );
  }
}
async function printNationalParkQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Parques nacionales', searchNationalParkPdf);
  }
}
function openLinkFunction(row) {
  if (!!row.url) {
    window.open(row.url, '_blank');
  } else {
    viewNationalParkPdf(row.id);
  }
}
// #endregion
// printQuery previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchNationalPark,
  recordToText: nationalParkToText,
  copyClipboard: copy,
  htmlQuery: htmlNationalParkQuery,
  printQuery: printNationalParkQuery,
  printRecord: printNationalPark,
  centerMap: goNationalPark,
  openLink: openLinkFunction,
  schema: NATIONAL_PARKS_SCHEMA,
});

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped></style>
